import { BaseViewStore, HyperlinkCellData } from 'core/stores';
import { action, observable, makeObservable } from 'mobx';
import { OrderLineStore } from 'modules/order-line/stores';
import _ from 'lodash';

class OrderLinesExpandListViewStore extends BaseViewStore {
	@observable change = false;
	data = [];
	showActions = false;
	noDataItem = true;

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.tableData = {
			columns: [
				{
					key: 'product.name',
					title: 'MARKETPLACEORDERS.VIEW.ORDERLINE.VIEW.PRODUCTNAME',
					dataCell: HyperlinkCellData,
					onClick: dataItem => this.openProductDetailPage(dataItem.id),
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
				{
					key: 'sku',
					title: 'MARKETPLACEORDERS.VIEW.ORDERLINE.VIEW.SKU',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
				{
					key: 'quantity',
					title: 'MARKETPLACEORDERS.VIEW.ORDERLINE.VIEW.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
					canFilter: false,
					resizable: false,
					sortable: false,
				},
			],
			sortObject: [],
			actions: {},
			permissions: {},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
						id,
					}),
			},
		};
		this.store = new OrderLineStore(rootStore);
		this.findOrderLine(componentProps.dataItem.id);
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound
	findOrderLine = async orderId => {
		this.suspend();
		this.data = (await this.store.findOrderLine({
			embed: ['product'],
			page: 1,
			rpp: 100,
			orderIds: [orderId],
		})).item.slice();
		this.setAsChanged();
		this.resume();
	};

	openProductDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id : id,
		});
	};
}

export default OrderLinesExpandListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderLinesExpandListViewStore.js